import { render, staticRenderFns } from "./workben_nav.vue?vue&type=template&id=aff733be&scoped=true&"
import script from "./workben_nav.vue?vue&type=script&lang=js&"
export * from "./workben_nav.vue?vue&type=script&lang=js&"
import style0 from "./workben_nav.vue?vue&type=style&index=0&id=aff733be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff733be",
  null
  
)

export default component.exports